import React, { useState, useEffect, useRef } from "react";
//naviagte import
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaTimes, FaCheck } from "react-icons/fa";



// CSS For Wallet
import "../../css/User/Kyc.css";

// Import Font Awesome
// For Solid Icon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCreditCard,
    faBell,
    faCommentDots,
    faStar,
    faUsers,
    faCircleCheck,
    faVideo,
    faBookmark,
    faUser,
    faCog,

} from "@fortawesome/free-solid-svg-icons";


// Import Iconify for icons
import { Icon } from "@iconify/react";




const BASE_URL = "http://192.168.1.10:8000";

function Kyc2() {
   


    // for top tabs functionality
    const [activeTab, setActiveTab] = useState("forYou");
    //navigate page
    const navigate = useNavigate();
    // for prime public button click 


    // for sidebar buttons
    const [activeSidebar, setActiveSidebar] = useState("prime");


    // for menu toggle functionality
    const [showSidebar, setShowSidebar] = useState(true);
    //kyc 
    const [nationalId, setNationalId] = useState("");



    return (
        <div className="page-wrapper">
            {/* <div className="page-container"> */}

            {/* ================= GLOBAL TOP-RIGHT ICONS ================= */}
            <div className="page-top-container">
                <nav className="navbar top-header px-3 px-md-5">
                    {/* <div className="logo">
                        <img src="/images/logo1.jpg" alt="logo1" />
                    </div> */}

                    {/*  */}
                    <div
                        className="company-logo"
                        onClick={() => setShowSidebar(prev => !prev)}
                    >
                        <img src="/images/logo1.jpg" alt="logo1" />
                    </div>
                    {/*  */}

                    <div className="search-box">
                        <i className="prime-search-icon"><Icon icon="ic:sharp-search" /></i>
                        <input
                            type="text"
                            placeholder="Search Politics , Parties and Leadership"
                        />
                    </div>

                    {/* <div className="header-icons">
                            <i className="bi bi-wallet2"></i>

                            <div className="icon-badge">
                                <i className="bi bi-bell"></i>
                                <span>5</span>
                            </div>

                            <i className="bi bi-chat-dots"></i>
                        </div> */}
                    <div className="global-icons d-flex gap-0 gap-md-2">
                        <span className="position-relative border-0">
                            <FontAwesomeIcon icon={faCreditCard} className="icon-box" />
                            <span className="global-creditCard-data position-absolute translate-middle badge rounded-pill bg-danger">
                                <Icon icon="ic:sharp-currency-rupee" /> 50
                            </span>
                        </span>
                        <span className="position-relative border-0">
                            <FontAwesomeIcon icon={faBell} className="icon-box" />
                            <span className="global-bell-data position-absolute translate-middle badge rounded-pill bg-danger">
                                5
                            </span>
                        </span>
                        <span className="position-relative border-0">
                            <FontAwesomeIcon icon={faCommentDots} className="icon-box" />
                            <span className="global-comment-data position-absolute translate-middle badge rounded-pill bg-danger">

                            </span>
                        </span>
                    </div>
                </nav>
            </div>

            {/* ================= PRIME LAYOUT CONTAINER ================= */}
            <div className="prime-layout">
                <div className="row prime-row">

                    {/* ================= LEFT SIDEBAR ================= */}
                    <div
                        className={`sidebar-container col-lg-3 col-md-3 d-md-block ${showSidebar ? "sidebar-hide" : "sidebar-show"} `}
                    >
                        <aside className="sidebar">
                            <ul className="left-menu">

                                <li
                                    className={activeSidebar === "prime" ? "menu-item active" : "menu-item"}
                                    onClick={() => setActiveSidebar("prime")}
                                >
                                    <FontAwesomeIcon icon={faStar} /> Prime
                                </li>


                                <li
                                    className={activeSidebar === "public" ? "menu-item active" : "menu-item"}
                                    onClick={() => setActiveSidebar("public")}
                                >
                                    <FontAwesomeIcon icon={faUsers} /> Public
                                </li>
                              


                                <li
                                    className={activeSidebar === "videos" ? "menu-item active" : "menu-item"}
                                    onClick={() => setActiveSidebar("videos")}
                                >
                                    <FontAwesomeIcon icon={faVideo} /> Videos
                                </li>

                                <li
                                    className={activeSidebar === "bookmarks" ? "menu-item active" : "menu-item"}
                                    onClick={() => setActiveSidebar("bookmarks")}
                                >
                                    <FontAwesomeIcon icon={faBookmark} /> Bookmarks
                                </li>

                                <li
                                    className={activeSidebar === "profile" ? "menu-item active" : "menu-item"}
                                    onClick={() => setActiveSidebar("profile")}
                                >
                                    <FontAwesomeIcon icon={faUser} /> Profile
                                </li>

                                <li
                                    className={activeSidebar === "settings" ? "menu-item active" : "menu-item"}
                                    onClick={() => setActiveSidebar("settings")}
                                >
                                    <FontAwesomeIcon icon={faCog} /> Settings
                                </li>

                            </ul>
                            <button className="create-post-btn"> + Create Post</button>
                        </aside>
                    </div>
                    {/*  */}

                    {/* ================= CENTER AREA ================= */}
                    <div className="col-md-9 col-12 wallet-div">
                        <div className="kyc-page">
      <div className="kyc-card">
        {/* Header */}
         <div className="kyc-header">
      <span
        className="back-arrow"
        onClick={() => navigate(-1)}
      >
        <FaArrowLeft />
      </span>

      <span className="kyc-title">KYC Verification</span>
    </div>

        {/* User Info */}
        <div className="kyc-user">
          <img
            src="https://i.pravatar.cc/100"
            alt="user"
            className="user-img"
          />
          <span className="user-name">
            Helena King <span className="verified"> <FontAwesomeIcon icon={faCircleCheck} className="verified-icon" /></span>
          </span>
        </div>

        {/* Steps */}
        <div className="kyc-steps">
          <div className="step active" onClick={() => navigate("/kyc")}>
  <span></span>
  <p>Personal Info</p>
</div>

<div className="step" onClick={() => navigate("/kyc/id-proof")}>
  <span></span>
  <p>ID Proof</p>
</div>

<div className="step" onClick={() => navigate("/kyc3")}>
  <span></span>
  <p>Bank details</p>
</div>
        </div>

        {/* Form */}
        <div className="kyc-form">
          <h3>ID Proof</h3>

        

          <input type="text" placeholder="Phone Number" />
          <input type="number" placeholder="Aadhar Number" />
          <input type="text" placeholder="D.O.B as per aadhar card" />

          <button className="continue01-btn">Continue</button>
        </div>
      </div>
    </div>



                    </div>
                </div>

                {/* ================= RIGHT SIDEBAR ================= */}

            </div>
        </div>





    );
}
export default Kyc2;